import { render, staticRenderFns } from "./EWFrequencyForm.vue?vue&type=template&id=686dfda5&"
import script from "./EWFrequencyForm.vue?vue&type=script&lang=js&"
export * from "./EWFrequencyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports